/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const PageCategoryDocument = gql`
    query PageCategory($order: String) {
  pageCategory(order: $order) {
    id
    title
    position
    pagesSortedByPosition {
      id
      title
    }
  }
}
    `;

/**
 * __usePageCategoryQuery__
 *
 * To run a query within a React component, call `usePageCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCategoryQuery({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePageCategoryQuery(baseOptions?: Apollo.QueryHookOptions<PageCategoryQuery, PageCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCategoryQuery, PageCategoryQueryVariables>(PageCategoryDocument, options);
      }
export function usePageCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCategoryQuery, PageCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCategoryQuery, PageCategoryQueryVariables>(PageCategoryDocument, options);
        }
// @ts-ignore
export function usePageCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCategoryQuery, PageCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<PageCategoryQuery, PageCategoryQueryVariables>;
export function usePageCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageCategoryQuery, PageCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<PageCategoryQuery | undefined, PageCategoryQueryVariables>;
export function usePageCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageCategoryQuery, PageCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCategoryQuery, PageCategoryQueryVariables>(PageCategoryDocument, options);
        }
export type PageCategoryQueryHookResult = ReturnType<typeof usePageCategoryQuery>;
export type PageCategoryLazyQueryHookResult = ReturnType<typeof usePageCategoryLazyQuery>;
export type PageCategorySuspenseQueryHookResult = ReturnType<typeof usePageCategorySuspenseQuery>;
export type PageCategoryQueryResult = Apollo.QueryResult<PageCategoryQuery, PageCategoryQueryVariables>;
export const UpdatePositionCategoriesDocument = gql`
    mutation UpdatePositionCategories($categoriesPriority: [GraphCategoryPriorityInput!]!) {
  updatePositionCategories(categoriesPriority: $categoriesPriority) {
    id
    position
    title
  }
}
    `;
export type UpdatePositionCategoriesMutationFn = Apollo.MutationFunction<UpdatePositionCategoriesMutation, UpdatePositionCategoriesMutationVariables>;

/**
 * __useUpdatePositionCategoriesMutation__
 *
 * To run a mutation, you first call `useUpdatePositionCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionCategoriesMutation, { data, loading, error }] = useUpdatePositionCategoriesMutation({
 *   variables: {
 *      categoriesPriority: // value for 'categoriesPriority'
 *   },
 * });
 */
export function useUpdatePositionCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePositionCategoriesMutation, UpdatePositionCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePositionCategoriesMutation, UpdatePositionCategoriesMutationVariables>(UpdatePositionCategoriesDocument, options);
      }
export type UpdatePositionCategoriesMutationHookResult = ReturnType<typeof useUpdatePositionCategoriesMutation>;
export type UpdatePositionCategoriesMutationResult = Apollo.MutationResult<UpdatePositionCategoriesMutation>;
export type UpdatePositionCategoriesMutationOptions = Apollo.BaseMutationOptions<UpdatePositionCategoriesMutation, UpdatePositionCategoriesMutationVariables>;
export const PageCategoryEditDocument = gql`
    mutation PageCategoryEdit($pageCategory: Int!, $title: String!) {
  pageCategoryEdit(pageCategory: $pageCategory, title: $title) {
    id
    title
  }
}
    `;
export type PageCategoryEditMutationFn = Apollo.MutationFunction<PageCategoryEditMutation, PageCategoryEditMutationVariables>;

/**
 * __usePageCategoryEditMutation__
 *
 * To run a mutation, you first call `usePageCategoryEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePageCategoryEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pageCategoryEditMutation, { data, loading, error }] = usePageCategoryEditMutation({
 *   variables: {
 *      pageCategory: // value for 'pageCategory'
 *      title: // value for 'title'
 *   },
 * });
 */
export function usePageCategoryEditMutation(baseOptions?: Apollo.MutationHookOptions<PageCategoryEditMutation, PageCategoryEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PageCategoryEditMutation, PageCategoryEditMutationVariables>(PageCategoryEditDocument, options);
      }
export type PageCategoryEditMutationHookResult = ReturnType<typeof usePageCategoryEditMutation>;
export type PageCategoryEditMutationResult = Apollo.MutationResult<PageCategoryEditMutation>;
export type PageCategoryEditMutationOptions = Apollo.BaseMutationOptions<PageCategoryEditMutation, PageCategoryEditMutationVariables>;
export const PageCategoryDeleteDocument = gql`
    mutation PageCategoryDelete($pageCategory: Int!) {
  pageCategoryDelete(pageCategory: $pageCategory)
}
    `;
export type PageCategoryDeleteMutationFn = Apollo.MutationFunction<PageCategoryDeleteMutation, PageCategoryDeleteMutationVariables>;

/**
 * __usePageCategoryDeleteMutation__
 *
 * To run a mutation, you first call `usePageCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePageCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pageCategoryDeleteMutation, { data, loading, error }] = usePageCategoryDeleteMutation({
 *   variables: {
 *      pageCategory: // value for 'pageCategory'
 *   },
 * });
 */
export function usePageCategoryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PageCategoryDeleteMutation, PageCategoryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PageCategoryDeleteMutation, PageCategoryDeleteMutationVariables>(PageCategoryDeleteDocument, options);
      }
export type PageCategoryDeleteMutationHookResult = ReturnType<typeof usePageCategoryDeleteMutation>;
export type PageCategoryDeleteMutationResult = Apollo.MutationResult<PageCategoryDeleteMutation>;
export type PageCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<PageCategoryDeleteMutation, PageCategoryDeleteMutationVariables>;
export const PageCategoryShowDocument = gql`
    query PageCategoryShow($pageCategory: Int!) {
  pageCategoryShow(pageCategory: $pageCategory) {
    id
    title
    pagePageCategories {
      id
      position
      positionMeQr
      isLanding
      page {
        id
        title
      }
    }
  }
}
    `;

/**
 * __usePageCategoryShowQuery__
 *
 * To run a query within a React component, call `usePageCategoryShowQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCategoryShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCategoryShowQuery({
 *   variables: {
 *      pageCategory: // value for 'pageCategory'
 *   },
 * });
 */
export function usePageCategoryShowQuery(baseOptions: Apollo.QueryHookOptions<PageCategoryShowQuery, PageCategoryShowQueryVariables> & ({ variables: PageCategoryShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCategoryShowQuery, PageCategoryShowQueryVariables>(PageCategoryShowDocument, options);
      }
export function usePageCategoryShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCategoryShowQuery, PageCategoryShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCategoryShowQuery, PageCategoryShowQueryVariables>(PageCategoryShowDocument, options);
        }
// @ts-ignore
export function usePageCategoryShowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCategoryShowQuery, PageCategoryShowQueryVariables>): Apollo.UseSuspenseQueryResult<PageCategoryShowQuery, PageCategoryShowQueryVariables>;
export function usePageCategoryShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageCategoryShowQuery, PageCategoryShowQueryVariables>): Apollo.UseSuspenseQueryResult<PageCategoryShowQuery | undefined, PageCategoryShowQueryVariables>;
export function usePageCategoryShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageCategoryShowQuery, PageCategoryShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCategoryShowQuery, PageCategoryShowQueryVariables>(PageCategoryShowDocument, options);
        }
export type PageCategoryShowQueryHookResult = ReturnType<typeof usePageCategoryShowQuery>;
export type PageCategoryShowLazyQueryHookResult = ReturnType<typeof usePageCategoryShowLazyQuery>;
export type PageCategoryShowSuspenseQueryHookResult = ReturnType<typeof usePageCategoryShowSuspenseQuery>;
export type PageCategoryShowQueryResult = Apollo.QueryResult<PageCategoryShowQuery, PageCategoryShowQueryVariables>;
export const PageCategoryNewDocument = gql`
    mutation PageCategoryNew($title: String!) {
  pageCategoryNew(title: $title) {
    id
    title
  }
}
    `;
export type PageCategoryNewMutationFn = Apollo.MutationFunction<PageCategoryNewMutation, PageCategoryNewMutationVariables>;

/**
 * __usePageCategoryNewMutation__
 *
 * To run a mutation, you first call `usePageCategoryNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePageCategoryNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pageCategoryNewMutation, { data, loading, error }] = usePageCategoryNewMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function usePageCategoryNewMutation(baseOptions?: Apollo.MutationHookOptions<PageCategoryNewMutation, PageCategoryNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PageCategoryNewMutation, PageCategoryNewMutationVariables>(PageCategoryNewDocument, options);
      }
export type PageCategoryNewMutationHookResult = ReturnType<typeof usePageCategoryNewMutation>;
export type PageCategoryNewMutationResult = Apollo.MutationResult<PageCategoryNewMutation>;
export type PageCategoryNewMutationOptions = Apollo.BaseMutationOptions<PageCategoryNewMutation, PageCategoryNewMutationVariables>;
export const UpdatePositionPagesDocument = gql`
    mutation UpdatePositionPages($pagesPriority: [GraphPagePriorityInput!]!) {
  updatePositionPages(pagesPriority: $pagesPriority) {
    id
  }
}
    `;
export type UpdatePositionPagesMutationFn = Apollo.MutationFunction<UpdatePositionPagesMutation, UpdatePositionPagesMutationVariables>;

/**
 * __useUpdatePositionPagesMutation__
 *
 * To run a mutation, you first call `useUpdatePositionPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionPagesMutation, { data, loading, error }] = useUpdatePositionPagesMutation({
 *   variables: {
 *      pagesPriority: // value for 'pagesPriority'
 *   },
 * });
 */
export function useUpdatePositionPagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePositionPagesMutation, UpdatePositionPagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePositionPagesMutation, UpdatePositionPagesMutationVariables>(UpdatePositionPagesDocument, options);
      }
export type UpdatePositionPagesMutationHookResult = ReturnType<typeof useUpdatePositionPagesMutation>;
export type UpdatePositionPagesMutationResult = Apollo.MutationResult<UpdatePositionPagesMutation>;
export type UpdatePositionPagesMutationOptions = Apollo.BaseMutationOptions<UpdatePositionPagesMutation, UpdatePositionPagesMutationVariables>;
export type PageCategoryQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PageCategoryQuery = { __typename?: 'Query', pageCategory?: Array<{ __typename?: 'GraphPageCategory', id?: number | null, title?: string | null, position?: number | null, pagesSortedByPosition: Array<{ __typename?: 'GraphPage', id?: number | null, title?: string | null }> }> | null };

export type UpdatePositionCategoriesMutationVariables = Types.Exact<{
  categoriesPriority: Array<Types.GraphCategoryPriorityInput> | Types.GraphCategoryPriorityInput;
}>;


export type UpdatePositionCategoriesMutation = { __typename?: 'Mutation', updatePositionCategories: Array<{ __typename?: 'GraphPageCategory', id?: number | null, position?: number | null, title?: string | null }> };

export type PageCategoryEditMutationVariables = Types.Exact<{
  pageCategory: Types.Scalars['Int']['input'];
  title: Types.Scalars['String']['input'];
}>;


export type PageCategoryEditMutation = { __typename?: 'Mutation', pageCategoryEdit: { __typename?: 'GraphPageCategory', id?: number | null, title?: string | null } };

export type PageCategoryDeleteMutationVariables = Types.Exact<{
  pageCategory: Types.Scalars['Int']['input'];
}>;


export type PageCategoryDeleteMutation = { __typename?: 'Mutation', pageCategoryDelete: boolean };

export type PageCategoryShowQueryVariables = Types.Exact<{
  pageCategory: Types.Scalars['Int']['input'];
}>;


export type PageCategoryShowQuery = { __typename?: 'Query', pageCategoryShow: { __typename?: 'GraphPageCategory', id?: number | null, title?: string | null, pagePageCategories: Array<{ __typename?: 'GraphPagePageCategory', id?: number | null, position?: number | null, positionMeQr?: number | null, isLanding?: boolean | null, page: { __typename?: 'GraphPage', id?: number | null, title?: string | null } }> } };

export type PageCategoryNewMutationVariables = Types.Exact<{
  title: Types.Scalars['String']['input'];
}>;


export type PageCategoryNewMutation = { __typename?: 'Mutation', pageCategoryNew: { __typename?: 'GraphPageCategory', id?: number | null, title?: string | null } };

export type UpdatePositionPagesMutationVariables = Types.Exact<{
  pagesPriority: Array<Types.GraphPagePriorityInput> | Types.GraphPagePriorityInput;
}>;


export type UpdatePositionPagesMutation = { __typename?: 'Mutation', updatePositionPages: Array<{ __typename?: 'GraphPagePageCategory', id?: number | null }> };
